export const was911Dialed = (phoneNumber: string) => {
  return phoneNumber.trim() === '911';
};
